import {createSlice} from '@reduxjs/toolkit'
import {ROUTE_PATH} from '../../app/constants'

const eligibilityConfirmationState = () => ({
    "collection-agency" : {
        header : 'Collection agency licensing',
        text : [
            "Does your company collect debt in Nova Scotia on behalf of another company?"
        ],
        navigation : {
            next : ROUTE_PATH.NS_LOGIN,
            previous : ROUTE_PATH.NOT_ELIGIBLE
        },
        eilibilityToCollectDept : false
    },
    "debt-management-agency" : {
        header : 'Debt management agency licensing',
        text : [
            "Does your company manage debt on behalf of debtors in Nova Scotia?"
        ],
        navigation : {
            next : ROUTE_PATH.NS_LOGIN,
            previous : ROUTE_PATH.NOT_ELIGIBLE
        },
        eilibilityToCollectDept : false
    },
    header : 'Collection agency licensing',
    text : [
        "Does your company collect debt in Nova Scotia on behalf of another company?"
    ],
    navigation : {
        next : ROUTE_PATH.NS_LOGIN,
        previous : ROUTE_PATH.NOT_ELIGIBLE
    },
    eilibilityToCollectDept : false
})

const eligibilityConfirmationSlice = createSlice({
    name: 'eligibilityConfirmation',
    initialState : eligibilityConfirmationState(),
    reducers : {
        setEligibleToCollectDept(state, action) { 
            state.eilibilityToCollectDept = action.payload
        }
    }
})

export const {setEligibleToCollectDept} = eligibilityConfirmationSlice.actions

export default eligibilityConfirmationSlice.reducer